export const installments = {
    isExternalPlanManagementAllowed: true,
    cardMenuItemTranslationKey: 'credit.main.installment.plans',
    overviewItemCardTranslationKey: 'cards.components.installments.custom.overview.charged',
};
